module.exports = __webpack_public_path__ + "static/media/separator_main.15e88cec.svg";